export default () => {
  const homeNavigation = document.querySelectorAll('.js-home-navigation');
  if (homeNavigation) {
    homeNavigation.forEach( nav => {        
      nav.querySelectorAll('.js-heading').forEach( item => {

        item.addEventListener('click', ev => {
          ev.preventDefault(); 
          ev.currentTarget.parentElement.classList.toggle('is-active');

          const navItemWrapper = document.querySelectorAll('.js-NavTransition');
          navItemWrapper.forEach( item => {
              item.classList.add('fade-in-bottom'); 
          });

        });

      });
    });
  }
}


    